import { render, staticRenderFns } from "./appoint-title.vue?vue&type=template&id=1555653e&scoped=true&"
import script from "./appoint-title.vue?vue&type=script&lang=js&"
export * from "./appoint-title.vue?vue&type=script&lang=js&"
import style0 from "./appoint-title.vue?vue&type=style&index=0&id=1555653e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1555653e",
  null
  
)

export default component.exports